

export const GoogleReviewSkeleton = () => {
  return (
    <div className="max-w-6xl mx-auto p-4">
      <div className="animate-pulse">
        <div className="h-16 bg-gray-200 rounded mb-6"></div>
        <div className="flex gap-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex-1 bg-gray-200 rounded-lg h-64"></div>
          ))}
        </div>
      </div>
    </div>
  )
}